
import PersonalSetting from './PersonalSetting';

export default PersonalSetting;
